<template>
  <div id="app">
    <div class="clearfix">
      <b-img class="my-2 mx-4" right :src="require('./assets/cd_logo.png')"  alt="Color Digital"></b-img>
    </div>
    <Navbar/>
    <router-view></router-view>
  </div>
</template>

<script>
import Dashboard from './components/Dashboard'
import Navbar from './components/NavBar'

export default {
  name: 'navbar',
  components: {Navbar, Dashboard}
}
</script>

<style>
  #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

  .btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
    background-color: #e37b23!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue